import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { VISIT_ROUTE, VISIT_ROUTE_STEP, DISCOVER_BOOKING_ROUTE } from '../constants'
import Visit from '../visit'
import Content from './content'
import Booking from '../booking'
import DiscoverBooking from '../DiscoverBooking/DiscoverBooking'
import DiscoverStep from '../DiscoverStep/DiscoverStep'
import Store from '../Store'
import qs from 'query-string'
import ChangePaymentMethod from '../changePaymentMethod'

const Routes = (props) => {
  // property/visit/:id
  // property/offer/:id
  return (
    <Switch>
      <Route exact path={`${DISCOVER_BOOKING_ROUTE}/change-payment-method/:bookingId`}>
        <ChangePaymentMethod {...props} />
      </Route>

      <Store>
        <Route exact path={VISIT_ROUTE_STEP}>
          <Content pageType="visit">
            <Visit {...props} />
          </Content>
        </Route>

        <Route exact path={VISIT_ROUTE}>
          <Content pageType="visit">
            <Visit {...props} />
          </Content>
        </Route>

        <Route exact path={DISCOVER_BOOKING_ROUTE}>
          <DiscoverBooking
            propertyId={qs.parse(props.location.search).property_id}
            legacyBookingId={qs.parse(props.location.search).booking_legacy_id}
          />
        </Route>

        <Route exact path={`${DISCOVER_BOOKING_ROUTE}/:bookingId`}>
          <DiscoverStep />
        </Route>

        <Route exact path={`${DISCOVER_BOOKING_ROUTE}/:bookingId/:step`}>
          <Content pageType="booking">
            <Booking {...props} />
          </Content>
        </Route>
      </Store>
    </Switch>
  )
}

export default withRouter(Routes)
